import { getDefaultPanelColors } from './get-default-panel-colors';

export function setDefaultPanelBg(themeWrapper: HTMLBodyElement): void {
  themeWrapper.style.setProperty('--panelBg', getDefaultPanelColors().panelBg);
}
